import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      closeButton
      duration={4000}
      position="bottom-right"
      richColors
      toastOptions={{
        classNames: {
          toast: 'font-sans',
        },
      }}
    />
  );
}
